export default "__VITE_ASSET__X5Aqmpva__"